var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossNoFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.32 12.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05.28a.94.94 0 0 0-1.32 0L6.16 4.84 1.59.27a.94.94 0 0 0-1.32 0 .94.94 0 0 0 0 1.32l4.57 4.57-4.57 4.57a.94.94 0 0 0 0 1.32.94.94 0 0 0 1.32 0l4.57-4.57 4.57 4.57a.93.93 0 0 0 1.32-1.32L7.48 6.16l4.57-4.57a1 1 0 0 0 0-1.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossNoFill);
export default __webpack_public_path__ + "static/media/cross-no-fill.aa617456947bed9113cbe8502e70463a.svg";
export { ForwardRef as ReactComponent };